<template>
  <bean-source-page
    :type="type"
    :columns="columns"
    :form-columns="formColumns"
    :filter-columns="filterColumns"
    :actions="actions"
    :form="form"
    :title="$t('model.jushuitanShop')"
    resource="jushuitan_shops"
    index-exec-filter-router-type="push"
    :batch-actions="batchActions"
  />
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator';
import { filterColumnsExtend, columnsExtend, formColumnsExtend } from '../admin_grapes/jushuitan_shops.js';
import _ from 'lodash';

@Component
export default class JushuitanShops extends Vue {
  @Prop(String) type;

  // form 新建表单初始化数据（default数据）
  form = {}

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - page type enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -RESTful api resource name
   */
  filterColumns() {
    const array = [
      'shop_name_cont',
      'shop_type_eq'
    ].filter(Boolean)

    return filterColumnsExtend(array)
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - page type enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -RESTful api resource name
   */
  columns(h, { type }) {
    const array = [
      type === 'show' && 'id',
      'shop_id',
      'shop_name',
      'shop_type',
      type === 'show' && 'created_at',
      type === 'show' && 'updated_at',
    ].filter(Boolean)

    return columnsExtend(array)
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - page type enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource - RESTful api resoure name
   * @param {Object} params.data - current form data
   * @param {Function} params.change - invoke this method to sync form change({ field: 'new value' })
   */
  formColumns(h, { data, type }) {
    const array = [
      {
        prop: 'shop_name',
        label: this.$t('jushuitanShop.shopName'),
        renderCell: {
          component: 'input',
          props: {
            disabled: true
          }
        }
      },
      'shop_type',
    ].filter(Boolean)

    return formColumnsExtend(array, { data: data, type: type })
  }

  /**
   * @param {Object} scope -页面/表格 scope 数据
   * @param {Object} scope.row - 详情页/表格行 数据
   * @param {Object} sourcePageScope
   * @param {Function} sourcePageScope.remove - sourcePage删除方法
   * @param {Function} sourcePageScope.reload - sourcePage重新请求页面数据
   */
  actions({ row }, { remove }) {
    return [
      {
        component: 'routeButton',
        props: {
          label: this.$t('edit'),
          to: { name: 'jushuitan_shops.edit', params: { id: row.id } }
        }
      },
      {
        component: 'confirmButton',
        props: {
          label: this.$t('destroy'),
          type: 'danger',
          can: 'jushuitan_shops.destroy'
        },
        on: {
          confirm: () => remove(row.id)
        }
      }
    ].filter(Boolean);
  }

  batchActions({ selection }, { resource }) {
    const exportClick = async (selection) => {
      if (selection.length === 0) {
        await this.$autoLoading(this.$request.get(`/${resource}/export`, { ...this.$route.query }));
      } else {
        await this.$autoLoading(this.$request.get(`/${resource}/export`, { ...this.$route.query, id_in: _.map(selection, item => item.id) }));
      }
      this.$message.success(this.$t('exporting'));
    }

    return [
      () => <el-button type='primary' onClick={() => exportClick(selection)}><i class='el-icon-download'></i>{this.$t('export')}</el-button>,
    ]
  }
}

export const route = [
  {
    path: '/jushuitan_shops',
    name: 'jushuitan_shops.index',
    component: JushuitanShops,
    props: {
      type: 'index',
    }
  },
  {
    path: '/jushuitan_shops/new',
    name: 'jushuitan_shops.new',
    component: JushuitanShops,
    props: {
      type: 'new',
    }
  },
  {
    path: '/jushuitan_shops/:id',
    name: 'jushuitan_shops.show',
    component: JushuitanShops,
    props: {
      type: 'show',
    }
  },
  {
    path: '/jushuitan_shops/:id/edit',
    name: 'jushuitan_shops.edit',
    component: JushuitanShops,
    props: {
      type: 'edit'
    }
  }
]
</script>
